module.exports = __webpack_public_path__ + "static/media/pencil.e5885a17.svg";